import { ReactComponent as OokiLogo } from 'bzx-common/src/assets/images/ooki-logo.svg'
import ThemeSwitch from 'bzx-common/src/shared-components/ThemeSwitch'
import { observer } from 'mobx-react'
import React from 'react'
import { Link } from 'react-router-dom'
import ExternalLink from 'shared-components/ExternalLink'
import { Button, ButtonClose, Icon, Tooltip } from 'ui-framework'
import { featuresLinks, linksSocials } from './headerConfig'
import HeaderMenu from './HeaderMenu'
import ReactTooltip from 'react-tooltip'
import HeaderVM from './HeaderVM'
import MainHelp from './MainHelp'
import OnChainIndicator from './OnChainIndicator'
import OokiDetails from './OokiDetails'

type TooltipRef = { tooltipRef: null } | null

const ookiLogoLink = (
  <Link to="/">
    <OokiLogo height="33" width="75" />
  </Link>
)

export function Header({ vm }: { vm: HeaderVM }) {
  const { isMobileMedia } = vm.uiStore.media
  const tooltip = React.useRef(null)

  if (isMobileMedia) {
    return (
      <header className="header">
        <div className="flex-row-center default-content-width justify-between padded-bottom-1">
          <div className="flex-row-center">{ookiLogoLink}</div>
          <div className="flex-row-center">
            <div className="margin-right-1">
              <OnChainIndicator rootStore={vm.rootStore} />
            </div>
            <Button variant="invisible" onClick={vm.sideMenu.toggle}>
              {vm.sideMenu.visible ? (
                <Icon size={24} name="arrow-right" bgPadding={4} />
              ) : (
                <Icon size={24} name="Burger-menu" />
              )}
            </Button>
          </div>
        </div>

        <div className={!vm.sideMenu.visible ? 'sidebar--hidden' : 'sidebar--visible'}>
          <div className="sidebar__overlay" onClick={vm.sideMenu.hide} />
          <div className="header__mobile-top-box">
            <div className="margin-right-1">
              <ThemeSwitch />
            </div>
            <div className="margin-right-1">
              <Button className="btn-menu-square" onClick={vm.helpDialog.toggle}>
                <Icon name="FAQ" size={25} color="var(--color-txt-muted)" />
              </Button>
            </div>
          </div>
          {vm.helpDialog.visible ? (
            <>
              <ButtonClose onClick={vm.helpDialog.hide} right={16} top={8} />
              <MainHelp vm={vm} />
            </>
          ) : (
            <>
              <div className="header_nav_menu margin-bottom-1">
                <HeaderMenu
                  items={featuresLinks}
                  isMobileMedia={isMobileMedia}
                  onMenuToggle={vm.sideMenu.toggle}
                />
              </div>
              <div className="bg-alternative flex-col-end">
                <div className="dropdown-margin flex-row-center justify-between">
                  {linksSocials.map((item) => {
                    return (
                      <ExternalLink key={item.title} href={item.url} title={item.title}>
                        <Icon name={item.icon} size={20} color="var(--color-txt-default)" />
                      </ExternalLink>
                    )
                  })}
                </div>
              </div>
            </>
          )}
        </div>
      </header>
    )
  }

  return (
    <header className="header">
      <div className="flex-row-center justify-between default-content-width margin-h-auto">
        <div className="flex-row-center">
          {ookiLogoLink}
          <HeaderMenu items={featuresLinks} isMobileMedia={isMobileMedia} />
        </div>
        <div className="flex-row-center">
          <div className="margin-right-1">
            <OokiDetails />
          </div>

          <div className="margin-right-1">
            <OnChainIndicator rootStore={vm.rootStore} />
          </div>
          <ThemeSwitch />
          <div
            className="btn-menu-square margin-left-1"
            data-tip
            data-for="info"
            data-event="click focus">
            <Icon name="FAQ" size={25} color="var(--color-txt-muted)" />
          </div>
          <Tooltip
            id="info"
            className="header__main-help-tip panel--simple"
            place={'bottom'}
            clickable={true}
            effect="solid"
            isCapture={true}
            globalEventOff="click"
            data-event-off="click"
            ref={tooltip}
            delayHide={200}>
            <ButtonClose
              onClick={() => {
                const current: TooltipRef = tooltip.current
                current!.tooltipRef = null
                ReactTooltip.hide()
              }}
              right={10}
              top={8}
            />
            <MainHelp vm={vm} />
          </Tooltip>
        </div>
      </div>
    </header>
  )
}

export default observer(Header)
